import classNames from 'classnames'
import React, { FC } from 'react'
import ArrowIcon from '../assets/icons/arrow.svg'
import { useTranslations } from '../hooks/useTranslations'
import { isNullOrWhiteSpace } from '../utilities/string'

export type Variant = 'file' | 'audiocast'

export interface Attachment {
  date?: string
  title: string
  type?: Variant
  url: string
}

export interface ReportAttachmentsListProps {
  attachments: Attachment[]
}

export const ReportAttachmentsList: FC<ReportAttachmentsListProps> = ({
  attachments,
}) => {
  const translations = useTranslations()

  if (!attachments?.length) {
    return null
  }

  return (
    <div className="flex flex-col">
      {attachments
        .filter(attachment => attachment.url)
        .map((attachment, index) => (
          // eslint-disable-next-line react/jsx-no-target-blank
          <a
            className={classNames(
              'group flex items-center justify-between border-b border-neutral-lighter text-secondary-darker font-t-bold text-t-300 py-7',
              'transition-hover hover:text-primary focus:text-primary focus:outline-none',
              'lg:text-t-500 lg:py-10',
              'xxl:py-15'
            )}
            href={attachment.url}
            key={index}
            rel="nofollow noopener"
            target="_blank"
          >
            <span>{attachment.title}</span>

            {attachment.type === 'audiocast' ? (
              <span
                className={classNames(
                  'text-primary font-t text-t-100 border border-neutral-light rounded-full px-20 py-7 uppercase transition-hover',
                  'group-hover:bg-primary group-hover:text-neutral group-hover:border-primary group-hover:duration-250',
                  'group-focus:ring group-focus:ring-primary/40 group-focus:border-primary'
                )}
              >
                {!isNullOrWhiteSpace(translations.webcastButton)
                  ? translations.webcastButton
                  : translations.play}
              </span>
            ) : (
              <span>
                <ArrowIcon
                  width="45"
                  height="45"
                  className="fill-current w-10 h-10 xl:w-10 xl:h-15 xxl:w-15 xxl:h-20"
                />
              </span>
            )}
          </a>
        ))}
    </div>
  )
}
